
import { createClient } from '@supabase/supabase-js';

// Safely retrieve environment variables with fallback to empty strings
const supabaseUrl = import.meta.env.VITE_PUBLIC_SUPABASE_URL ?? '';
const supabaseAnonKey = import.meta.env.VITE_PUBLIC_SUPABASE_ANON_KEY ?? '';

if (!supabaseUrl) {
  console.warn('Supabase URL is not set. Please check VITE_PUBLIC_SUPABASE_URL environment variable.');
}
if (!supabaseAnonKey) {
  console.warn('Supabase anon key is not set. Please check VITE_PUBLIC_SUPABASE_ANON_KEY environment variable.');
}

// Create Supabase client with proper configuration
export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  auth: {
    autoRefreshToken: true,
    persistSession: true,
    detectSessionInUrl: true,
    flowType: 'pkce',
  },
});
